module.exports = __webpack_public_path__ + "img/ic-contact-line.ca836aff.png";